import { useEffect } from 'react';
import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector, useSportsbookSelector } from 'js/store/hooks';
import { getCleanPath } from 'js/utils/url.util';

import * as actions from '../store/actions';

export const useSportsbookFetch = () => {
    const dispatch = useDispatch();
    const { globalSportsScriptPromise } = window;
    const { pathname } = useLocation();
    const sportsbookRootURL = useAppSelector(prop('sportsbookRootURL'));
    const {
        isNeedToStart,
        isAppInitialized,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching,
        isIntegrationScriptError
    } = useSportsbookSelector(pick([
        'isNeedToStart',
        'isAppInitialized',
        'isIntegrationScriptFetched',
        'isIntegrationScriptFetching',
        'isIntegrationScriptError'
    ]));

    useEffect(() => {
        const sportPageRegExp = new RegExp(`(^${sportsbookRootURL}$)|(^${sportsbookRootURL}/)`);
        const isSportPage = sportPageRegExp.test(getCleanPath(pathname));

        if (isSportPage || !isAppInitialized) {
            dispatch(actions.startIntegration());
        }
    }, [dispatch, isAppInitialized, pathname, sportsbookRootURL]);

    useEffect(() => {
        if (!isNeedToStart || isIntegrationScriptFetched || isIntegrationScriptFetching || isIntegrationScriptError) {
            return;
        }

        dispatch(actions.setIntegrationScriptFetching());

        if (!globalSportsScriptPromise) {
            dispatch(actions.setIntegrationScriptError());
            return;
        }

        globalSportsScriptPromise
            .then(() => dispatch(actions.setIntegrationScriptFetched()))
            .catch(() => dispatch(actions.setIntegrationScriptError()));
    }, [
        dispatch,
        isNeedToStart,
        isIntegrationScriptError,
        globalSportsScriptPromise,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching
    ]);
};
